{
  "PlaysoundLabel": "Geluid afspelen (lokale mediaspeler vereist):",
  "ActivewindowLabel": "Actief venster (alleen IE\/Firefox-browsers met één tabblad):",
  "AlarmActions_SectionHeader": "Alarmacties",
  "AlarmActions_SectionPara": "Wanneer alarmen zijn geactiveerd, knipperen de bijbehorende rapportrij en\/of statistieken. Hieronder kunt u extra acties kiezen die plaatsvinden voor het momenteel actieve rapport wanneer een van de alarmen voor het eerst wordt geactiveerd.",
  "NAME": "AlarmActions"
}